import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http } from "@/lib/api";
import { Clock } from "lucide-react";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    http.get("/posts").then((r) => setPosts(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="container-editorial py-16 lg:py-24" data-testid="page-blog">
      <div className="max-w-3xl">
        <span className="pill">Blog</span>
        <h1 className="mt-4 font-display text-5xl sm:text-6xl tracking-tighter leading-[0.95]">Pensieri, ricerche, riflessioni.</h1>
        <p className="mt-6 text-lg text-viola/75">Articoli sul lavoro clinico, sessualità, identità, relazioni non normative. Rigorosi ma leggibili — e sempre inclusivi.</p>
      </div>

      {loading ? (
        <p className="mt-16 text-viola/60" data-testid="blog-loading">Caricamento…</p>
      ) : posts.length === 0 ? (
        <div className="mt-16 rounded-2xl bg-lilla p-12 text-center" data-testid="blog-empty">
          <p className="font-display text-2xl">Presto i primi articoli.</p>
          <p className="mt-3 text-viola/70">Iscriviti alla newsletter per non perderli.</p>
        </div>
      ) : (
        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map((p) => (
            <Link to={`/blog/${p.slug}`} key={p.id} className="group" data-testid={`blog-card-${p.slug}`}>
              <div className="aspect-[4/3] overflow-hidden rounded-xl bg-lilla mb-4">
                {p.cover_url ? (
                  <img src={p.cover_url} alt={p.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                ) : <div className="h-full w-full bg-gradient-to-br from-lilla to-arancio/40" />}
              </div>
              <div className="flex flex-wrap gap-2">
                {(p.categories || []).slice(0, 2).map((c) => <span key={c} className="pill">{c}</span>)}
              </div>
              <h2 className="mt-3 font-display text-2xl leading-tight group-hover:text-fucsia transition-colors">{p.title}</h2>
              <p className="mt-2 text-sm text-viola/70 line-clamp-2">{p.excerpt}</p>
              <p className="mt-3 text-xs text-viola/60 flex items-center gap-3">
                <span>{new Date(p.created_at).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" })}</span>
                <span className="flex items-center gap-1"><Clock size={12} /> {p.read_minutes || 5} min</span>
              </p>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
